module.exports = __webpack_public_path__ + "media/images/icons/envira-brands-4741d44b52e5e91c2ca9d77753455924.svg";